import jsPDF from "jspdf";

/**
 * Helper to get accurate SVG dimensions
 */
const getSvgDimensions = (svg) => {
  const viewBox = svg.getAttribute("viewBox");
  if (viewBox) {
    const [, , width, height] = viewBox.split(" ").map(Number);
    return { width, height };
  }
  return {
    width: svg.width.baseVal.value || svg.clientWidth,
    height: svg.height.baseVal.value || svg.clientHeight,
  };
};

/**
 * Export D3 chart as SVG
 */
export const exportAsSVG = (svgId, fileName = "chart.svg") => {
  const svgElement = document.getElementById(svgId);
  if (!svgElement) return alert("SVG element not found");

  const serializer = new XMLSerializer();
  const svgBlob = new Blob([serializer.serializeToString(svgElement)], {
    type: "image/svg+xml;charset=utf-8",
  });
  const svgUrl = URL.createObjectURL(svgBlob);

  const link = document.createElement("a");
  link.href = svgUrl;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(svgUrl);
};

/**
 * Export D3 chart as PNG
 */
export const exportAsPNG = (svgId, fileName = "chart.png") => {
  const svgElement = document.getElementById(svgId);
  if (!svgElement) return alert("SVG element not found");

  const serializer = new XMLSerializer();
  const svgString = serializer.serializeToString(svgElement);

  const { width, height } = (() => {
    const viewBox = svgElement.getAttribute("viewBox");
    if (viewBox) {
      const [, , w, h] = viewBox.split(" ").map(Number);
      return { width: w, height: h };
    }
    return {
      width: svgElement.width.baseVal.value || svgElement.clientWidth,
      height: svgElement.height.baseVal.value || svgElement.clientHeight,
    };
  })();

  const canvas = document.createElement("canvas");
  canvas.width = width * 2;
  canvas.height = height * 2;
  const ctx = canvas.getContext("2d");
  ctx.scale(2, 2);

  // ✅ Fill white background before drawing SVG
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, width, height);

  const img = new Image();
  const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(svgBlob);

  img.onload = () => {
    ctx.drawImage(img, 0, 0, width, height);
    URL.revokeObjectURL(url);

    const pngUrl = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = pngUrl;
    link.download = fileName;
    link.click();
  };

  img.src = url;
};

/**
 * Export D3 chart as PDF
 */
export const exportAsPDF = (svgId, fileName = "chart.pdf") => {
  const svgElement = document.getElementById(svgId);
  if (!svgElement) return alert("SVG element not found");

  const { width, height } = getSvgDimensions(svgElement);
  const serializer = new XMLSerializer();
  const svgString = serializer.serializeToString(svgElement);

  const canvas = document.createElement("canvas");
  canvas.width = width * 2;
  canvas.height = height * 2;
  const ctx = canvas.getContext("2d");
  ctx.scale(2, 2);

  const img = new Image();
  const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
  const url = URL.createObjectURL(svgBlob);

  img.onload = () => {
    ctx.drawImage(img, 0, 0, width, height);
    URL.revokeObjectURL(url);

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: width > height ? "landscape" : "portrait",
      unit: "pt",
      format: [width, height],
    });

    pdf.addImage(imgData, "PNG", 0, 0, width, height);
    pdf.save(fileName);
  };
  img.src = url;
};
